import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  deleteAllowancesBonuss,
  getAllowancesBonuss,
  getCategorys,
  insertAllowancesBonuss,
  getallowancebonusType
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from '../pages/FilterComponent'
import { data } from "jquery";

export default function AllowancesBonus() {
  const UID = localStorage.getItem("userId");
  const [addAllowancesBonusModal, setAddAllowancesBonusModal] = useState(false);
  const [editAllowancesBonusModal, setEditAllowancesBonusModal] =
    useState(false);
  const [allowancesBonuss, setAllowancesBonuss] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [commonDatas, setCommonDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [AllowancesBonussType, setAllowancesBonussType] = useState()
  const [allowancesBonusIdToDelete, setAllowancesBonusIdToDelete] =
    useState(null);
  const [filterText, setFilterText] = React.useState("");
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const [typeName, setTypeName] = useState("Type not found");
  const [allowancesBonusData, setAllowancesBonusData] = useState({
    Id: "",
    Name: "",
    Narration: "",
    MinWorkingDays: "",
    CategoryId: "",
    Amount: "",
    NoOfTerms: "",
    AdvanceAmount: "",
    UserId: UID,
    Type: '',
    typeName:""
  });

useEffect(()=>{
  console.log(allowancesBonusData,'allow');
  
},[allowancesBonusData])
  
useEffect(() => {
  const foundType = AllowancesBonussType?.find(
    (type) => type.ID === allowancesBonusData.Type
  )?.type || "Type not found";
  setTypeName(foundType);
  console.log(foundType);
  
}, [allowancesBonusData.Type]); 

  console.log('sss', typeName);


  const clearData = () => {
    setAllowancesBonusData({
      Id: "",
      Name: "",
      Narration: "",
      MinWorkingDays: "",
      CategoryId: "",
      Amount: "",
      NoOfTerms: "",
      AdvanceAmount: "",
      UserId: UID,
      Type: '',
      
    });
    setTypeName('')
  };

  const clearDataEdit = () => {
    setAllowancesBonusData((ref) => ({
      ...ref,
      Name: "",
      Narration: "",
      MinWorkingDays: "",
      CategoryId: "",
      Amount: "",
      NoOfTerms: "",
      AdvanceAmount: "",
      UserId: UID,
      Type: '',
      Profitcenter: "Select Category",
    }));
  };

  const openAddAllowancesBonusModal = () => {
    clearData();
    setAddAllowancesBonusModal(!addAllowancesBonusModal);
    fetchAllowancesBonuss();
  };

  const openEditAllowancesBonusModal = (data) => {
    console.log(data, 'dfghj');
    const CommonDataName = commonDatas.find(
      (item) => item.Id === data?.CategoryId
    );
    setEditAllowancesBonusModal(!editAllowancesBonusModal);
    setAllowancesBonusData({
      ...data,
      Profitcenter: CommonDataName?.Name,
      UserId: UID || "",
    });
  };

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };

  const fetchAllowancesBonuss = async () => {
    try {
      const data = await getAllowancesBonuss(UID);
      setAllowancesBonuss(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching allowancesBonuss", error);
    }
    setLoading(false);
  };

  

  // const handleChange = (e) => {
  //   console.log(e.target.value, 'llll');

  //   const { name, value } = e.target;
  //   setAllowancesBonusData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'NoOfTerms' && value !== '') {
      if (parseInt(value) >= allowancesBonusData.AdvanceAmount) {
        toast.error('Number of Terms must be less than the Advance Amount');
        return
      } else {
        
      }
    }
  
    setAllowancesBonusData((prev) => {
      const updatedData = { ...prev, [name]: value };
  
      // If the field being updated is "Type", find and set the corresponding typeName
      if (name === "Type") {
        const foundTypeName = AllowancesBonussType?.find((type) => type.ID === value)?.type || "Type not found";
        updatedData.typeName = foundTypeName;
      }
      return updatedData;
    });
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await insertAllowancesBonuss(allowancesBonusData);

      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchAllowancesBonuss();
        openAddAllowancesBonusModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Same Categoty Same Name detected. Please use unique values")) {
        toast.error("Same Categoty Same Name detected. Please use unique values");
      } else {
        toast.error("Same Categoty Same Name detected. Please use unique values.");
      }
      console.error("Error adding allowancesBonus:", error);
    } finally {
      setLoading(false);
    }
  };

  // ========================================================edit===========================================================================
  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await insertAllowancesBonuss(allowancesBonusData);

      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        fetchAllowancesBonuss();
        openEditAllowancesBonusModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name or Code")) {
        toast.error(" An error occured Please try after some time");
      } else {
        toast.error("Error occurred while editing Allowances Bonus.");
      }
      console.error("Error editing allowancesBonus:", error);
    } finally {
      setLoading(false);
    }
  };

  const removeAllowancesBonus = async (allowancesBonusId) => {
    const removeData = { Id: allowancesBonusId, TableName: "AllowancesBonus" };
    try {
      const res = await deleteAllowancesBonuss(removeData, UID);
      console.log(res, "dpo");

      if (res && res.data) {
        // Ensure the response has the expected structure
        if (res.status === 200 && res.data.message === "Deleted Successfully") {
          toast.success("Allowances Bonus deleted successfully");
          fetchAllowancesBonuss(); // Refresh the list
        } else {
          toast.error(res.data.message || "Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Allowances and Bonus");
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Allowances and Bonus.";
        toast.error('Allowances and Bonus already using cannot delete');
      } else {
        console.error("Error removing Allowances and Bonus:", error);
        toast.error("Error deleting Allowances and Bonus. Please try again.");
      }

    }
  };

  const openModal = (allowancesBonusId) => {
    setAllowancesBonusIdToDelete(allowancesBonusId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setAllowancesBonusIdToDelete(null);
  };

  const confirmDelete = () => {
    if (allowancesBonusIdToDelete) {
      removeAllowancesBonus(allowancesBonusIdToDelete);
    }
    closeModal();
  };

  const filteredItems = dataFilter.filter((item) => {
    // Retrieve category safely
    const category = commonDatas.find((el) => el.Id === item.CategoryId)?.Name;
    const typeName = AllowancesBonussType?.find(
      (type) => type.ID === item.Type // Assuming `item.Type` is the correct field
    )?.type || "Type not found";
  
    // Convert filter text to lowercase once for performance
    const filterTextLower = filterText.toLowerCase();
  
    // Ensure each field is a string for comparison
    const name = item.Name ? String(item.Name).toLowerCase() : "";
    const code = item.Code ? String(item.Code).toLowerCase() : "";
    const narration = item.Narration ? String(item.Narration).toLowerCase() : "";
    const categoryName = category ? String(category).toLowerCase() : "";
    const typeNameLower = typeName ? String(typeName).toLowerCase() : "";
    
  
    // Return items that match the filter text in any of the fields
    return (
      name.includes(filterTextLower) ||
      code.includes(filterTextLower) ||
      narration.includes(filterTextLower) ||
      categoryName.includes(filterTextLower) ||
      typeNameLower.includes(filterTextLower)
    );
  });
  

  // ===================================================Columns=======================================================================
  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Allowances&Bonus",
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.Code,
      sortable: true,
    },
    // {
    //   name: "Category",
    //   selector: (row) => {
    //     const category = commonDatas.find((el) => el.Id === row.CategoryId);
    //     return category ? category.Name : "N/A"; // Handle case where category is not found
    //   },
    //   sortable: true,
    // },
    {
      name: "Type",
      selector: (row) => {
        const typeName = AllowancesBonussType?.find(
          (type) => type.ID === row.Type
        )?.type || "Type not found";
        return typeName;
      },
      sortable: true
  },
  {
    name: "Amount",
    selector: (row) => {
      const typeAmount = AllowancesBonussType?.find((el) => el.ID === row.Type);
      if (typeAmount) {
        return typeAmount.type === "Advance" ? row.AdvanceAmount : row.Amount;
      }
      return null;
    },
    sortable: true,
  },
  

    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditAllowancesBonusModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];

  const fetchAllowancesBonussType = async () => {
    try {
      const data = await getallowancebonusType(UID);
      console.log(data, "Fetched data");
      setAllowancesBonussType(data.data.data);
      console.log(AllowancesBonussType, "naameeee");
    } catch (error) {
      console.error("Error fetching leaveTypes", error);
    }
  };

  



  const subHeaderComponentMemo = useMemo(() => {




  }, [filterText, resetPaginationToggle]);
  useEffect(() => {
    fetchAllowancesBonussType()
  }, []);
  // ========================================================UseEffects===========================================================================

  useEffect(() => {
    if (allowancesBonuss && allowancesBonuss.length > 0) {
      const updatedData = allowancesBonuss.map((item, index) => ({
        Slno: index + 1,

        Id: item.Id || "",
        Name: item.Name || "",
        Narration: item.Narration || "",
        Code: item.Code || "",
        MinWorkingDays: item.MinWorkingDays || "",
        CategoryId: item.CategoryId || "",
        Amount: item.Amount || "",
        Type: item.Type || "",
        AdvanceAmount: item.AdvanceAmount || "",
        NoOfTerms: item.NoOfTerms || "",
        UserId: UID || "",
        typeName:item.typeName||""
      }));
      setDataFilter(updatedData);
    }else {
      setDataFilter([]);
    }
  }, [allowancesBonuss]);

  useEffect(() => {
    const fetchCommonDatas = async () => {
      try {
        const response = await getCategorys(UID);

        setCommonDatas(response.data.data);
        console.log(commonDatas, "pro");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchCommonDatas();
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchAllowancesBonuss();
  }, []);


  useEffect(() => {
    console.log('allowancesBonusData', allowancesBonusData);

  }, [allowancesBonusData])


  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };





  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Allowance and Bonus?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
  <div className="flex items-center justify-between mb-8">
  <Breadcrumb title="Allowances & Bonus"/>

  {/* Action Area */}
  <div className="flex items-center gap-4">
    {/* Search and Clear Buttons */}
    <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
      <button
        className="bg-sky rounded-[4px] px-10 py-[8px]"
        onClick={handleFilterClick}
      >
        <IconFilter className="text-white w-[18px] h-[18px]" />
      </button>
      <div className="relative">
        <input
          type="text"
          id="search"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Search by Allowances & Bonus/Code/Type"
          className="w-[300px] px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>
      <button
        onClick={handleClear}
        className="btn btn-danger"
      >
        Clear
      </button>
    </div>

    {/* Add New Button */}
    <button
      onClick={openAddAllowancesBonusModal}
      className="btn btn-primary"
    >
      Add New
    </button>
  </div>
</div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={allowancesBonuss} onFilter={handleFilter} />
      )}

      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        {/* <div className="flex items-center justify-between gap-15 mb-30">
          <p className="text-[16px]/[19.2px] font-medium">
            Allowances & Bonus List
          </p>
          <div className="flex gap-5 mb-10 w-full justify-end">
        <div className="relative w-full max-w-[221px]">
          <input
            type="text"
            id="search"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            placeholder="Search here..."
            className="bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] placeholder:text-text-secondary focus:outline-none"
          />
        </div>
        <button onClick={handleClear} className="btn btn-danger">
          Clear
        </button>
      </div>
          <button
            onClick={openAddAllowancesBonusModal}
            className="btn btn-primary"
          >
            Add New
          </button>
        </div> */}







        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
      {addAllowancesBonusModal && (
        <>
          <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add Allowances & Bonus
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openAddAllowancesBonusModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form
                onSubmit={handleSubmit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px]  "
              >

                <div className="my-10 md:px-10 px-[7px]">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="form-group flex flex-col gap-2">
                      <label>
                      Allowances&Bonus <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="Name"
                        placeholder="Name"
                        value={allowancesBonusData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                        
                      />
                    </div>

                    <div className="form-group flex flex-col gap-2">
                      <label htmlFor="allowanceBonusSelect">Choose Type <span style={{ color: "red" }}>*</span></label>
                      <select id="allowanceBonusSelect" onChange={handleChange} name="Type"  value={allowancesBonusData.Type||''} required>
                        <option value="">Choose One</option>
                        {AllowancesBonussType.map((item, index) => (
                          <option key={index} value={item.ID}>
                            {item.type}
                          </option>
                        ))}
                      </select>
                    </div>

                    {typeName === 'Advance' && (
                      <>
                        <div className="form-group flex flex-col gap-2">
                          <label>
                            Advance Amount <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="number"
                            id="Code"
                            name="AdvanceAmount"
                            placeholder="AdvanceAmount"
                            value={allowancesBonusData.AdvanceAmount}
                            onChange={handleChange}
                            required
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                        <div className="form-group flex flex-col gap-2">
                          <label>
                            Number of Terms (For Repayment) <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="number"
                            id="terms"
                            name="NoOfTerms"
                            placeholder="Number of Terms"
                            value={allowancesBonusData.NoOfTerms}
                            onChange={handleChange}
                            required
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>

                      </>
                    )}
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Min Working Days <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="MinWorkingDays"
                        name="MinWorkingDays"
                        placeholder="Min Working Days"
                        onWheel={(e) => e.target.blur()}
                        value={allowancesBonusData.MinWorkingDays}
                        onChange={handleChange}
                        required

                      />
                    </div>
                    {typeName != 'Advance' && (
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Amount <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="Amount"
                        name="Amount"
                        placeholder="Amount"
                        onWheel={(e) => e.target.blur()}
                        value={allowancesBonusData.Amount}
                        onChange={handleChange}
                        required

                      />
                    </div>
                ) }
                    <div className="form-group flex flex-col gap-2 md:col-span-2">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={allowancesBonusData.Narration}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                    disabled={loading}
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            // onClick={openAddAllowancesBonusModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

      {/* ========================================================EDIT======================================================== */}
      {editAllowancesBonusModal && (
        <>
          <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit Allowances & Bonus
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openEditAllowancesBonusModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>

              <form
                onSubmit={handleEdit} // Attach your submit handler
                className="my-10 md:px-10 px-[7px]  "
              >
                <div className="my-10 md:px-10 px-[7px]">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="form-group flex flex-col gap-2">
                      <label>
                      Allowances&Bonus <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="Name"
                        name="Name"
                        placeholder="Name"
                        value={allowancesBonusData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                        
                      />
                    </div>
                    <div className="form-group flex flex-col gap-2">
                      <label htmlFor="allowanceBonusSelect">
                        Choose Type <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        id="allowanceBonusSelect"
                        value={allowancesBonusData.Type}
                        onChange={handleChange}
                        name="Type"
                        required
                      >
                        <option>Choose One</option>
                        {AllowancesBonussType.map((item, index) => (
                          <option key={index} value={item.ID}>
                            {item.type}
                          </option>
                        ))}
                      </select>
                    </div>

                   
                    {allowancesBonusData.Type === "8896C9E2-581C-44A8-9D72-0FA1DEBAA2E8" && (
                      <>
                        <div className="form-group flex flex-col gap-2">
                          <label>
                            Advance Amount <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="number"
                            id="AdvanceAmount"
                            name="AdvanceAmount"
                            placeholder="AdvanceAmount"
                            value={allowancesBonusData.AdvanceAmount}
                            onChange={handleChange}
                            required
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                        <div className="form-group flex flex-col gap-2">
                          <label>
                          Number of Terms (For Re Payment)  <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="number"
                            id="terms"
                            name="NoOfTerms"
                            placeholder="Number of Terms"
                            value={allowancesBonusData.NoOfTerms}
                            onChange={handleChange}
                            required
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                      </>
                    )}

                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Min Working Days <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="MinWorkingDays"
                        name="MinWorkingDays"
                        placeholder="MinWorkingDays"
                        value={allowancesBonusData?.MinWorkingDays}
                        onChange={handleChange}
                        required
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    {typeName != 'Advance' && (
                    <div className="form-group flex flex-col gap-2">
                      <label>
                        Amount <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="Amount"
                        name="Amount"
                        placeholder="Amount"
                        value={allowancesBonusData.Amount}
                        onChange={handleChange}
                        required
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    )}

                    <div className="form-group flex flex-col gap-2 md:col-span-2">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="Narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={allowancesBonusData.Narration}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            // onClick={openEditAllowancesBonusModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
